import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AgentLayoutIndex from '../_layouts'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  mail_templates: {
    mail_templates: IJsonResponse
  }
  posts: IJsonResponse
  user: IJsonResponse
}

const COLUMNS = [
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.title'),
    field: 'title',
    required: true,
  },
  {
    name: I18n.t('generic.tour'),
    field: 'posts',
  },
]

const AgentMailTemplatesIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Agent Thanks Mail')
  const { data: mailTemplatesList, pagination } = agentService.getDataFromJson(
    props.mail_templates.mail_templates
  )
  const { data: postsList } = agentService.getDataFromJson(props.posts)
  const { data: user } = agentService.getDataFromJson(props.user)
  const formedTemplatesList = mailTemplatesList
    .filter(
      (template, index, self) => self.findIndex(compare => template.id === compare.id) === index
    )
    .map(template => {
      const postNames: string[] = []
      template.posts.forEach(templatePost => {
        postNames.push(
          postsList.find(data => String(data.id) === String(templatePost.id))?.name || ''
        )
      })
      const posts = postNames.join(', ')
      return {
        ...template,
        posts,
      }
    })
  const [mailTemplates, setMailTemplates] = React.useState(formedTemplatesList)
  const handleClickDelete = record => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(record.id)
    }
  }
  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await agentService.deleteMailTemplate(id)
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setMailTemplates(mailTemplates.filter(mailTemplate => mailTemplate.id !== id))
    },
    [mailTemplates]
  )

  const renderRecordControls = React.useCallback(
    record => (
      <>
        <Button key="edit" small={true}>
          <a href={`/agent/mail_templates/${record.id}/edit`}>{I18n.t('generic.edit')}</a>
        </Button>
        <Button key="delete" small={true} handleClick={() => handleClickDelete(record)}>
          {I18n.t('generic.delete')}
        </Button>
      </>
    ),
    []
  )

  return (
    <SidebarLayout user={user} showSidebar={true}>
      <AgentLayoutIndex
        model="mail_template"
        hideAgentNav={true}
        title={
          <Heading>
            <span>{I18n.t('mail_template.thanks_mail')}</span>
            <Button small={true}>
              <a href="/agent/mail_templates/new">{I18n.t('generic.create_new')}</a>
            </Button>
          </Heading>
        }
        main={
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={mailTemplates}
            pagination={pagination}
            handleDelete={null}
            getEditLink={null}
            renderRecordControls={renderRecordControls}
          />
        }
      />
    </SidebarLayout>
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default AgentMailTemplatesIndex
